import React from "react"

interface Props {
  onRestart: VoidFunction
}

export const Restart: React.FC<Props> = (props) => {
  const { onRestart } = props

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        height: 600,
      }}
    >
      <button onClick={onRestart} style={{ background: "none" }}>
        <img
          src={process.env.PUBLIC_URL + "/images/play_circle.svg"}
          alt="play"
        />
      </button>
      <div style={{ color: "white" }}>Replay from Start</div>
    </div>
  )
}
